import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  keyLoading,
  resetVietnameseProvinces,
  selectLoading,
  selectVietnameseProvinces,
} from './store/slice'
import { getVietnameseProvincesThunk } from './store/thunk'

let cacheKey = null

const useGetVietnameseProvinces = () => {
  const dispatch = useDispatch()

  const locale = useSelector((state) => state.i18n.locale)
  const loading = useSelector(selectLoading(keyLoading.VIETNAMESE_PROVINCES))
  const vietnameseProvinces = useSelector(selectVietnameseProvinces)

  useEffect(() => {
    if (cacheKey !== locale) {
      cacheKey = locale
      dispatch(getVietnameseProvincesThunk())
    }
  }, [locale])

  useEffect(() => {
    return () => dispatch(resetVietnameseProvinces())
  }, [])

  return {
    loading,
    vietnameseProvinces,
  }
}

export default useGetVietnameseProvinces
